import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useAccountStore } from '@/stores/account';
import { computed } from 'vue';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'Trackers',
  setup(__props) {

const router = useRouter()
const accountStore = useAccountStore()


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_app_bar, { height: "60" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_tabs, {
          color: "primary",
          class: "ml-4"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_tab, {
              to: "/trackers",
              height: "60"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { class: "mr-1" }, {
                  default: _withCtx(() => [
                    _createTextVNode("mdi-view-grid")
                  ]),
                  _: 1
                }),
                _createTextVNode(" Список трекеров ")
              ]),
              _: 1
            }),
            _createVNode(_component_v_tab, {
              to: "/trackers/supervising",
              height: "60"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { class: "mr-1" }, {
                  default: _withCtx(() => [
                    _createTextVNode("mdi-file-document")
                  ]),
                  _: 1
                }),
                _createTextVNode(" Результаты супервизии ")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_router_view)
  ], 64))
}
}

})